export const roles = [
  { value: 1, label: "Administrador" },
  { value: 2, label: "Desenvolvedor" },
  { value: 3, label: "Marketing" },
];
